<template>
    <div class='sign-fc-panel'>
        <ul class="download-panel">
            <li>
                <p class="song-name">人间</p>
                <a class="download-link yq-download-link" href="http://5sing.kugou.com/yc/3703451.html" target="_blank" >原曲</a>     
                <a class="download-link bz-download-link" href="http://5sing.kugou.com/bz/3075797.html"  target="_blank" >伴奏</a>                                                
            </li>
            <li>
                <p class="song-name">最美</p>   
                <a class="download-link yq-download-link" href="http://5sing.kugou.com/yc/3703371.html" target="_blank" >原曲</a>     
                <a class="download-link bz-download-link" href="http://5sing.kugou.com/bz/3075795.html"  target="_blank" >伴奏</a>                                                
            </li>
        </ul>
        <template v-if="w20.indexOf(winConfig.uid) >= 0">
            <input v-model="fclink" class="sign-textbox" type="text" placeholder="仅支持翻唱歌曲链接，如http://5sing.kugou.com/fc/3312005.html" >
            <a class="sign-button" href="javascript:;" v-on:click="validFC">我要参赛</a>
        </template>
        
    </div>
</template>
<script>
const fcRule =  /^http:\/\/5sing.kugou.com\/(fc)+\/\d+.html$/;
const mvRule =  /^http:\/\/5sing.kugou.com\/\d+\/Video\/(\d+).html$/;
let mv_id;
export default {
    name: "sign-fc",
    data() {
        return {
            winConfig: this.$winConfig,
            columnIndex: 2,
            fclink: "",
            mvlink: "",
            type: 'fc',
            dialogImageUrl: "",
            dialogVisible: false,
            isHttp: false,
            w20: [
                40521668,49567929,34582006,63663275,733942,39439421,3901976,25834235,54694358,3837538,13966308,49466363,
                8231799,63953035,35999549,65685579,27822481,55719604,16343633,67137421,11083896,49457280
            ]
        };
    },
    mounted:function(){
        var _this = this;
        eventbus.$on("signMsg", function (res) {
            if(!_this.isHttp && res.type == 'signSuccess-'+_this.type){
                _this.isHttp = true;
                _this.signFC();
            }
        });  
    },
    methods: {
        /**
         * 翻唱报名参赛。
         * @param {string} id     加密栏目id。
         * @param {string} url    原创报名歌曲地址。
         * @param {number} isApp  是否使用app报名，其中1表示使用手机端进行报名；不传递该参数表示使用PC端进行报名。默认不传该参数。
         * @param {string} sign   如果使用了app进行报名（即isApp设置为1）时必须传递该参数，否则报名失败。
         * @param {number} type   报名类型，其中1表示歌曲报名；2表示歌单报名。默认歌曲报名。
         *
         */
        validFC:function(){
            if(!this.$winConfig.isLogin){
                this.$tipsBox.error({
                    message: "请先登录",
                    reload: "http://5sing.kugou.com/login/"
                });
            }else{
                if (this.fclink == "") {
                    this.$tipsBox.error({
                        message: "请填写歌曲地址！"
                    });
                } else if (fcRule.test(this.fclink)) {
                    this.$signMsg.show({type: this.type});
                }else{
                    this.$tipsBox.error({
                        message: "请使用翻唱歌曲报名参赛！"
                    });
                }
            }
        },
        signFC: function(event) {
            if(this.fclink != ""){
                 let formData = {
                    sid: this.winConfig.signConfig[this.columnIndex].id,
                    signup_type: 2,
                    music_address: this.fclink
                };
                this.signHttp(formData);
            } 
        },
        /**
         * 报名请求。
         * @param {object} formData         请求参数
         * @param {string} ADD_WORK_URL     请求地址
         */
        signHttp: function(formData) {
            var _this = this;
            _this.$server.sign(formData).then(function(res){
                res = res.data;
                if (res.code == 10010) {
                    _this.$tipsBox.error({
                        message: "请先登录",
                        reload: "http://5sing.kugou.com/login/"
                    });
                } else if (12311 === res.status) {
                    _this.$tipsBox.error({
                        message: "该歌曲已报名成功，请不要重复提交。"
                    });
                } else if (12303 === res.status) {
                    _this.$tipsBox.error({
                        message: "请确认歌曲状态正常再报名参赛！"
                    });
                } else if (12305 === res.status) {
                    _this.$tipsBox.error({
                        message: "请使用自己的翻唱作品报名！"
                    });
                } else if (0 === res.status) {
                    _this.$tipsBox.tips({
                        message: "报名成功！数据同步可能延迟，请耐心等待。",
                    });
                    //清空报名数据
                    _this.fclink = '';
                    eventbus.$emit("reloadSong", {type:'success'});
                } else {
                    _this.$tipsBox.error({
                        message: res.message
                    });
                }
                _this.isHttp = false;
            }).catch(function(res){
                _this.isHttp = false;
                _this.$tipsBox.error({
                    message: "服务器开小差，请稍后再试..."
                });
            });
        }
    }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.sign-fc-panel{
    .download-panel{
        width: 1200px;
        padding-bottom: 40px;
        text-align: left;
        li{
            display: inline-block;
            width:  390px;
            padding: 10px 0 10px 50px;
            margin: 20px 32px 0 0;
            color: #3e149d;
            border: 1px solid #3e149d;
            background: #fff url(componentsImgPath('index/song_1.png')) 3% center no-repeat;
        }
        .song-name{
            display: inline-block;
            width: 50%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            vertical-align: middle;
        }
        .download-link{
            display: inline-block;
            padding: 0 30px 0 15px;
            margin-right:  15px ;
            color: #3e149d;
            background: url(componentsImgPath('index/song_2.png')) right center no-repeat;
        }
        .bz-download-link{
            border-left:1px solid #3e149d;
        }
        .qc-download-link{
            padding:0 0 0 25px ;
            background-image: none;
            border-left:1px solid #3e149d;
        }
    }
    .sign-textbox {
        display: inline-block;
        width: 680px;
        height: 45px;
        padding: 0 10px;
        margin-right: 20px;
        color: #3e149d;
        border: 1px solid #fff;
        border-radius: 4px;
        background-color: #e8e3f4;
        vertical-align: middle;
        &::-webkit-input-placeholder{
            color: #9f9fa0;
        }
        &::-moz-placeholder{   /* Mozilla Firefox 19+ */
            color:#9f9fa0;
        }
        &:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
            color:#9f9fa0;
        }
    }
    .sign-button {
        display: inline-block;
        width: 177px;
        height: 55px;
        line-height: 50px;
        margin: 10px auto;
        font-size: 25px;
        letter-spacing: .1em;
        color: #542eab;
        border-radius: 4px;
        text-align: center;
        vertical-align: middle;
        background: url(componentsImgPath('index/sign-btn.png')) right center no-repeat;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/sign-tab-fc.vue